import { IsString, MaxLength } from 'class-validator';

export class ResourceSearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}
